import React from 'react'
import {Button, Icon, Popup} from 'semantic-ui-react'

const filtersButton = (showFilters, toggleFilters) => {
  return (
    <div>
      <Popup content={showFilters ? 'Hide Filters' : 'Show Filters'} position='left center'
        trigger={
          <Button icon basic={!showFilters} primary={showFilters} onClick={toggleFilters} style={{float: 'right'}}>
            <Icon name='filter' />
          </Button>
        }
      />
    </div>
  )
}

export {filtersButton}
